<template>
  <div id="reInspectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{ title }}</p>
      </header>

      <section class="modal-card-body" style="width: 100%; text-align: left">
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th style="vertical-align:top; text-align:left; width:15%;">再検査理由</th>
            </tr>
            <tr>
              <td>
                <select name="dismissal" v-model="selectedReason">           
                  <!-- 空選択 -->
                  <option :value="null"></option>

                  <!-- 読み込み中 -->
                  <option v-if="isLoading" disabled>
                    選択肢を読み込み中…
                  </option>

                  <!-- データなし（読み込み完了後） -->
                  <option
                    v-else-if="!isLoading && data.length === 0"
                    disabled
                  >
                    登録されている選択肢なし
                  </option>

                  <!-- データあり -->
                  <option
                    v-else
                    v-for="(item, idx) in data"
                    :key="item.id != null ? item.id : idx"
                    :value="item"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </td>
            </tr>

            <tr>
              <th style="vertical-align:top; text-align:left; width:15%;">理由</th>
            </tr>
            <tr>
              <td>
                <textarea
                  v-model="reason"
                  maxlength="512"
                  style="resize: vertical; width:100%; max-width:100%; height:300px;"
                ></textarea>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="reasonSanitized.length === 0">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "reInspectModal",
  props: ["title", "targetChoiceValue", "targetScreenName", "targetChoiceType"],
  data() {
    return {
      // APIから受け取る配列（例：[{ id, title, detail }, ...]）
      data: [],

      // テキストエリアの内容
      reason: "",

      //ローディングフラグ
      isLoading: false,

      // セレクトの選択値（オブジェクトを直で保持）
      selectedReason: null,
    };
  },
  computed: {
    // 全角/半角スペース除去後の文字列で空チェック
    reasonSanitized() {
      return this.reason.replaceAll(" ", "").replaceAll("　", "");
    }
  },
  watch: {
    // セレクト変更時にtextareaへ自動反映
    selectedReason(newItem) {
      this.reason = newItem && newItem.detail ? newItem.detail : "";
    },
  },
  methods: {
    save() {
      if (this.reasonSanitized.length === 0) {
        this.showMessage("理由が入力されていません。");
        return;
      }
      this.$parent.close();
      this.$emit("setReason", this.reason);
    },

    // ---- API 呼び出し群 ----
    getReInspectReasons() {
      this.isLoading = true;
      var excuteApi = this.getReInspectReasonsPOST;
      var successCallBack = this.getReInspectReasonsPOSTSuccess;
      var errorCallBack = this.getReInspectReasonsPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getReInspectReasonsPOST(client) {
      const reqParam = {
        targetScreenName: this.targetScreenName,
        targetChoiceValue: this.targetChoiceValue,
        targetChoiceType: this.targetChoiceType,
      }
      return client.apis.apiCommon.getReInspectReasonsPOST({
        body:reqParam
      });
    },
    getReInspectReasonsPOSTSuccess(result) {
      this.isLoading = false;
      // 期待する返却形：result.obj.reasonData = [{ id?, title, detail }, ...]
      var list = (result && result.obj && Array.isArray(result.obj.reasonData))
        ? result.obj.reasonData
        : [];
      this.data = list;

      // すでに何か選択済みなら、最新dataにあわせて再反映（id一致で探す）
      if (this.selectedReason && this.data.length > 0) {
        var selId = this.selectedReason.id;
        if (selId !== undefined && selId !== null) {
          var latest = this.data.find(function(d) { return String(d.id) === String(selId); });
          if (latest) {
            this.selectedReason = latest;
          }
        }
      }
    },
    getReInspectReasonsPOSTError(result) {
      this.isLoading = false;
      this.showErrorMessage(result);
    },
  },
  mounted() {
    this.getReInspectReasons();
  },
};
</script>

<style lang="scss" scoped>
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/reInspectModal.vue